import React, { useEffect, useState } from 'react'
import { Link, Outlet } from 'react-router-dom'
import Table from '../../Components/Script/Table'
import { createUser, GetAllRole, GetAllUser, updateUser } from '../../Services/userProfile';

function CreateUser() {const [AllUsers, setAllUsers] = useState([]);
    const [roles, setRoles] = useState([]);  // State to store roles
    const [UserName, setUserName] = useState('');
    const [Password, setPassword] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    // const [UserId, setUserId] = useState('');  // Assuming UserId is stored in localStorage or fetched
    const user = JSON.parse(localStorage.getItem("user"));
    const [selectedUser, setSelectedUser] = useState(null);  // State to track selected user for password update
    const [newPassword, setNewPassword] = useState('');

    useEffect(() => {
        fetchAllUser();
        fetchAllRoles();  // Fetch roles when the component is mounted
    }, []);

    const fetchAllUser = async () => {
        try {
            const data = await GetAllUser();
            setAllUsers(data);
        } catch (error) {
            console.error('Error fetching credit card applications:', error);
        }
    };

    const fetchAllRoles = async () => {
        try {
            const rolesData = await GetAllRole();
            setRoles(rolesData);  // Set roles in state
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {
            username: UserName,
            password: Password,
            roleId: selectedRole,  // Send selected role ID
            createdBy: user.id,  // Send the current user ID or another identifier for createdBy
        };

        try {
            await createUser(formData);  // Call the createUser API to insert the user
            // alert('User created successfully');
            // You may want to redirect or refresh the user list
            fetchAllUser();
            setUserName('');
            setPassword('');
            setSelectedRole('');
        } catch (error) {
            console.error('Error creating user:', error);
            alert('User creation failed');
        }
    };
    const handleupdate = (user) => {
        setSelectedUser(user);
        setNewPassword('');
        new window.bootstrap.Modal(document.getElementById('password-update-modal')).show();
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
    
        if (!newPassword) {
            alert("Please enter a new password.");
            return;
        }
    
        const formData = {
            userId: selectedUser.id,  // Make sure to pass the correct user ID
            newPassword: newPassword, // Pass the new password
        };
    
        try {
            // Update password using the correct API endpoint
            await updateUser(selectedUser.id, formData);  // Assuming the updateUser API is configured correctly
            fetchAllUser();
            const modalElement = document.getElementById('password-update-modal');
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
            modalInstance?.hide();
        } catch (error) {
            console.error('Error updating password:', error);
            alert('Password update failed');
        }
    };
    
  return (
    <div>
      <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">User</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">User</h4>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                                    <div className="row g-2">
                                                        <div className="mb-3 col-md-4">
                                                            <label htmlFor="inputUserName" className="form-label">User Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="inputUserName"
                                                                value={UserName}
                                                                onChange={(e) => setUserName(e.target.value)}
                                                                placeholder="User Name"
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-md-4">
                                                            <label htmlFor="inputPassword" className="form-label">Password</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="inputPassword"
                                                                value={Password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                placeholder="Password"
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-md-4">
                                                            <label htmlFor="inputRole" className="form-label">Role</label>
                                                            <select
                                                                className="form-control"
                                                                id="inputRole"
                                                                value={selectedRole}
                                                                onChange={(e) => setSelectedRole(e.target.value)}
                                                            >
                                                                <option value="">Select Role</option>
                                                                {roles.map((role) => (
                                                                    <option key={role.id} value={role.id}>
                                                                        {role.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <button type="submit" className="btn btn-primary">Submit</button>
                                                </form>
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="tab-content">
                                                <div className="tab-pane show active" id="fixed-columns-preview">

                                                    <div className="table-responsive">
                                                        <table id="fixed-columns-datatable" className="table table-striped table-bordered table-hover nowrap row-border order-column w-100">
                                                            <thead>
                                                                <tr>
                                                                    <th>User Name</th>
                                                                    <th>Password</th>
                                                                    <th>Role</th>
                                                                    <th>Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {AllUsers.length > 0 ? (
                                                                    AllUsers.map((user) => (
                                                                        <tr key={user.id}>
                                                                            <td>{user.username}</td>
                                                                            <td>{user.password}</td>
                                                                            <td>{user.role.name}</td>
                                                                            <td className="table-action">
                                                                            <i
                                                                                className="mdi mdi-pencil action-icon"
                                                                                onClick={() => handleupdate(user)}
                                                                                style={{ cursor: "pointer" }}
                                                                            ></i>
                                                                        </td>

                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan="8" className="text-center">No Data Found</td>
                                                                    </tr>
                                                                )}


                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div> {/* end preview*/}
                                            </div> {/* end tab-content*/}
                                        </div> {/* end card body*/}
                                    </div> {/* end card */}
                                </div>{/* end col*/}
                            </div> {/* end row*/}
                            {selectedUser && (
                    <div className="modal fade" id="password-update-modal" tabIndex="-1" aria-labelledby="password-update-modalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="password-update-modalLabel">Update Password For &nbsp;</h5>
                                    <h5 className="mt-2">{selectedUser.username}</h5>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handlePasswordUpdate}>
                                        <div className="mb-3">
                                            <label htmlFor="newPassword" className="form-label">New Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                id="newPassword"
                                                value={newPassword}
                                                onChange={(e) => setNewPassword(e.target.value)}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-primary">Update Password</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </div>
    </div>
  )
}

export default CreateUser
